import { Badge } from '@fluentui/react-components'

const statusColorMap: { [key: string]: 'danger' | 'success' | 'warning' } = {
  Closed: 'danger',
  Open: 'success',
  Ongoing: 'warning',
}

const statusLabelMap: { [key: string]: string } = {
  Closed: 'Stängd',
  Open: 'Live',
  Ongoing: 'Pågående',
}

export const getStatusBadgeLabel = (status: string) =>
  statusLabelMap[status] ?? status

interface StatusBadgeProps {
  status: string
  size?: 'small' | 'medium' | 'large' | 'extra-large' | 'tiny' | 'extra-small'
  style?: React.CSSProperties
}

const StatusBadge = ({ status, size = 'medium', style }: StatusBadgeProps) => (
  <Badge
    appearance="filled"
    color={statusColorMap[status]}
    size={size}
    style={{ padding: 8, ...style }}
  >
    {getStatusBadgeLabel(status)}
  </Badge>
)

export default StatusBadge
